import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 22 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4 0.5H13.5C13.5834 0.5 13.6636 0.532868 13.7227 0.591797L21.0078 7.87695C21.0668 7.9359 21.0995 8.01626 21.0996 8.09961V23C21.0996 24.933 19.5326 26.5 17.5996 26.5H4C2.067 26.5 0.5 24.933 0.5 23V4C0.5 2.067 2.067 0.5 4 0.5Z",
			fill: "url(#paint0_linear_10430_48200)",
			stroke: "#D5D7DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5 0.337891V4.10039C13.5 6.30953 15.2909 8.10039 17.5 8.10039H21.2625",
			stroke: "#D5D7DA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.3001 12C12.1955 12 11.3001 12.8954 11.3001 14C11.3001 15.1046 12.1955 16 13.3001 16C14.4047 16 15.3001 15.1046 15.3001 14C15.3001 12.8954 14.4047 12 13.3001 12Z",
			fill: "#535862"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.1832 16.9776C12.9379 16.8759 12.6623 16.8759 12.4171 16.9776C12.2315 17.0546 12.1047 17.1883 12.0132 17.3017C11.9328 17.4014 11.8468 17.5287 11.7546 17.6669L10.3578 15.6494C10.257 15.5037 10.163 15.3679 10.0758 15.2635C9.98423 15.1539 9.85843 15.0259 9.67669 14.952C9.43524 14.8539 9.16499 14.8539 8.92354 14.952C8.7418 15.0259 8.61599 15.1539 8.52443 15.2635C8.43723 15.3679 8.34326 15.5037 8.24243 15.6494L5.24574 19.9779C5.11561 20.1658 4.99896 20.3343 4.91819 20.4773C4.83774 20.6197 4.74457 20.8163 4.75552 21.0473C4.76948 21.3419 4.9127 21.6152 5.1469 21.7943C5.33062 21.9348 5.54533 21.9702 5.7082 21.9851C5.8717 22 6.07661 22 6.30518 22L13.8001 22C13.8019 22 13.8037 22 13.8055 22L14.3269 22C14.5511 22 14.7527 22 14.9139 21.9852C15.0753 21.9705 15.2869 21.9354 15.4692 21.7975C15.7024 21.6211 15.8467 21.3515 15.8641 21.0596C15.8777 20.8314 15.7895 20.6359 15.7123 20.4935C15.6352 20.3511 15.5233 20.1834 15.399 19.9969L13.8707 17.7045C13.769 17.5519 13.6747 17.4104 13.5871 17.3017C13.4956 17.1883 13.3687 17.0546 13.1832 16.9776Z",
			fill: "#535862"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_10430_48200",
			x1: 10.8,
			y1: 0,
			x2: 10.8,
			y2: 27,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "white" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F5F5F5"
			})]
		}) })
	]
});
export default SvgImageIcon;
